<template>
  <div class="w-full rounded-10 h-auto">
    <div>
      <div class="flex gap-5">
        <div class="w-1/3 rounded-14 bg-gradient-to-b from-primaryStart to-primaryEnd relative overflow-hidden">
          <div class="bg-white rounded-14 m-4 flex items-center relative z-10">
            <div class="p-5 rounded-14 m-">
              <img
                :src="images.entreprises"
                alt="sollicitation"
                class="w-68 h-68"
              >
            </div>
            <div>
              <div class="text-gray2 text-c18 font-c5 uppercase">
                Nombre d’entreprises
              </div>
              <div class="font-c8 text-c32 text-left inputo">
                {{ accountData.allCompany || 0 }}
              </div>
            </div>
          </div>

          <div class="flex items-center justify-between relative z-10 mt-14">
            <div class="text-whiteGray font-c8 text-c24 text-left p-5 ">
              <div class="">
                Associées à un comptable
              </div>
              <div class="inputo">
                {{ stats.companyAffectation || 0 }}
              </div>
            </div>
          </div>

          <div
            class="absolute bottom-0 right-0  w-5/6 h-64 opacity-50 bg-no-repeat bg-bottom bg-right bg-cover mt-8" 
            :style="{ backgroundImage: `url(${images.bgAssocie})` }"
          />
        </div>

        <div class="w-1/3 rounded-14 bg-white">
          <div class="flex items-center m-2">
            <div class="inline-block m-4">
              <img
                :src="images.sollicitaion"
                alt="sollicitation"
                class="w-68 h-68"
              >
            </div>
            <div class="text-left">
              <div class="text-gray2 text-c18 font-c5 uppercase">
                SOLLICITATIONS De SERVICES
              </div>
              <div class="font-c7 text-c32 text-left inputo">
                {{ stats.serviceRequest || 0 }}
              </div>
            </div>
          </div>
          <div class="bg-greyy py-3 rounded-14 mx-5">
            <solicitation />
          </div>
        </div>

        <div class="w-1/3 rounded-14 bg-white">
          <div class="flex items-center m-3">
            <div class=" inline-block m-4">
              <img
                :src="images.comptable"
                alt="sollicitation"
                class="w-79 h-68"
              >
            </div>
            <div class="text-left">
              <div class="text-gray2 text-c18 font-c5 uppercase">
                Nombre d'experts comptables
              </div>
              <div class="font-c7 text-c32 inputo text-left">
                {{ stats.certifiedAccountant || 0 }}
              </div>
            </div>
          </div>
          <div class="p-10 border-t-4 border-gray flex items-center justify-between">
            <div class="text-left">
              <div class="font-c7 text-c18 uppercase">
                EN ATTENTE DE VALIDATION
              </div>
              <div class="font-c7 text-c24 2xl:text-c32 uppercase">
                {{ stats.awaitAccountantRequest || 0 }}
              </div>
            </div>
            <div class="">
              <icon
                :data="icons.icReloadComptable"
                width="50"
                height="50"
                class="icon-custom"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgAssocie from '../../../assets/images/webp/bgAssocie.webp'
import sollicitaion from '../../../assets/images/png/sollicitation.png'
import comptable from '../../../assets/images/png/comptable.png'
import programme from '../../../assets/images/png/programme.png'
import entreprises from '../../../assets/images/png/entreprises.png'
import icCampagne from '../../../assets/icons/ic-campagne.svg'
// import icSolicitation from '../../../assets/icons/ic-solicitation.svg'
import icComptableNumber from '../../../assets/icons/ic-comptableNumber.svg'
import icReloadComptable from '../../../assets/icons/ic_reloadCompta.svg'
import solicitation from './sollictationStats.vue'

export default {
  name: "AdminDashboard",
    props: {
    stats: {
      type: Object,
      required: true,
    },
    accountData: {
      type: Object,
      required: true,
    },
  },
  components: {
    solicitation,
  },
data() {
  return {
    icons: {
      icCampagne,
      icComptableNumber,
      icReloadComptable,
    },
    images: {
      bgAssocie,
      sollicitaion,
      comptable,
      programme,
      entreprises
    },

    charge: false // Indicateur de chargement
  };
},

}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/sass/variables.scss";
.diviser1{
  width: 2.68px;
  height: 33.91px;
  background: #79E38D;
}

.allB{
  height: 373px;
}

.diviser2{
  width: 2.68px;
  height: 33.91px;
  background: #7BD0FF;
}
.inputo{
  font-family: $font-default2;
}
</style>
